<template>
  <b-container fluid>
    <h1>Parent Certificates</h1>
    <div v-if="loaded">
      <mio-output
        :method="ParentCertificatesData.method"
        :messages="ParentCertificatesData.messages"
        :tables="ParentCertificatesData.tables"
        size="half"
      />
    </div>
    <h2 v-else>Loading...</h2>
  </b-container>
</template>

<script>
import { mapActions } from 'vuex';
import { set, get, validateRow } from '@/utils/MioHelpers';
import MioOutput from '@/components/MioOutput';

export default {
  name: 'MioParentCertificates',
  components: {
    MioOutput,
  },
  data() {
    return {
      loaded: false,
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      GET_PARENT_CERTIFICATES: "mio/GET_PARENT_CERTIFICATES",
    }),
    async getData() {
      try {
        await this.GET_PARENT_CERTIFICATES();

        this.loaded = true;
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    ParentCertificatesData: {
      get() {
        let input = this.$store.state.mio.parentCertificates;
        let working = {};
        let output = {
          method: "Aggregated from the parents certificates table, cross-referenced (via teachers and group records) with trainers and cooordinators to calculate averages. ",
          messages: [],
        };
        let cols = {};

        Object.keys(input).forEach(row => {
          input[row].count = String(input[row].parents_uuid.length) || null;
          let [valid, message, year, count, country, trainerID, coordID] = validateRow(input[row], ['year', 'count', 'country', 'trainer_uuid', 'coordinator_uuid']);
          if (!valid) {
            output.messages.push(`record is missing some data: ${message}`);
            return;
          }

          cols[country] = {};
          set(working, `data.rows.countryTotals.${year}.${country}`, count, 'add');
          set(working, `data.rows.countryTotals.${year}.All`, count, 'add');

          // Save trainer / coordinator in lists per country per year, then calculate running averages
          set(working, `trainers.${year}.${country}.${trainerID}`, {});
          set(working, `trainers.${year}.All.${trainerID}`, {});
          set(working, `data.rows.trainerAvg.${year}.${country}`, (working.data.rows.countryTotals[year][country] / Object.keys(working.trainers[year][country]).length).toFixed(1));
          set(working, `data.rows.trainerAvg.${year}.All`, (working.data.rows.countryTotals[year]['All'] / Object.keys(working.trainers[year]['All']).length).toFixed(1));
          set(working, `coordinators.${year}.${country}.${coordID}`, {});
          set(working, `coordinators.${year}.All.${coordID}`, {});
          set(working, `data.rows.coordAvg.${year}.${country}`, (working.data.rows.countryTotals[year][country] / Object.keys(working.coordinators[year][country]).length).toFixed(1));
          set(working, `data.rows.coordAvg.${year}.All`, (working.data.rows.countryTotals[year]['All'] / Object.keys(working.coordinators[year]['All']).length).toFixed(1));
        });

        // Sort columns
        cols = Object.keys(cols).sort().concat('All');
        set(working, `data.cols`, cols);

        // Format for output
        output.tables = [
          {
            title: 'number handed out per Country',
            cols: working.data.cols,
            rows: Object.keys(working.data.rows.countryTotals).sort().reverse().map(year => ({
              title: year,
              data: working.data.cols.map(country => working.data.rows.countryTotals[year][country]),
            })),
          },
          {
            title: 'number handed out per Trainer',
            cols: working.data.cols,
            rows: Object.keys(working.data.rows.trainerAvg).sort().reverse().map(year => ({
              title: year,
              data: working.data.cols.map(country => working.data.rows.trainerAvg[year][country]),
            })),
          },
          {
            title: 'number handed out per Regional Coordinator',
            cols: working.data.cols,
            rows: Object.keys(working.data.rows.coordAvg).sort().reverse().map(year => ({
              title: year,
              data: working.data.cols.map(country => working.data.rows.coordAvg[year][country]),
            })),
          },
        ];

        // console.log(working);
        // console.log(output);
        return output;
      }
    },
  },
};
</script>
